import React, { useEffect, useState, useRef } from "react";
import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { Header } from "./components/header/Header";
import { Hero } from "./components/hero/Hero";
import { About } from "./components/about/About";
import { Features } from "./components/features/Features";
import { Roadmap } from "./components/roadmap/Roadmap";
import { Utility } from "./components/utility/Utility";
import { Prizes } from "./components/prizes/Prizes";
import { Team } from "./components/team/Team";
import { Faq } from "./components/faq/Faq";
import { Whitepaper } from "./components/whitepaper/Whitepaper";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import { Page2 } from "./components/page2/Page2";
import { Enter } from "./components/enter/Enter";
import { Disclaimer } from "./components/disclaimer/Disclaimer";

import whiteList from "./utils/Whitelist";

import { MerkleTree } from "merkletreejs";
import keccak256 from "keccak256";

// const merkleRoot =  (address) => {

// };

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

function App() {
  // const [error, setError]= useState("You are not in whiteList")
  const [isError, setIsError] = useState(false);
  const [merkleProof, setMerkleProof] = useState([]);
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Click buy to mint your NFT.`);
  const [mintAmount, setMintAmount] = useState(1);
  const [nftCost, setNftCost] = useState(0.09);
  const [publicMint, setPublicMint] = useState(0);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const claimNFT = () => {
    console.log("mintfunction");
    // let cost = CONFIG.WEI_COST;
    const publicCost = data.publicCost;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(publicCost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    // console.log("Cost: ", totalCostWei);
    // console.log("Gas limit: ", totalGasLimit);
    // console.log("blockchain: ", blockchain.smartContract);
    // console.log(data.totalSupply ? data.totalSupply : typeof data.totalSupply);
    // console.log(data.publicCost ? data.publicCost : typeof data.publicCost);
    // console.log(
    //   data.whiteListCost ? data.whiteListCost : typeof data.whiteListCost
    // );
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(1)
      .send({
        // gasLimit: String(totalGasLimit),
        // to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        // value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        console.log(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit tofunft.com to view it.`
        );
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit tofunft.com to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };
  const claimNFTs = () => {
    console.log("Claim mint function");
    blockchain.smartContract.methods
      .mint(1)
      .send({ from: blockchain.account })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        console.log(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit tofunft.com to view it.`
        );
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit tofunft.com to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };
  const whiteListMint = async () => {
    console.log("WhiteListMintfunction");
    // const whiteListCost = data.whiteListCost;
    // let gasLimit = CONFIG.GAS_LIMIT;
    // let totalCostWei = String(whiteListCost * mintAmount);
    // let totalGasLimit = String(gasLimit * mintAmount);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .whitelistMint(
        // [
        //   "0x15ae9b8298ce04c043cbb1125cd0fb0988dce521beb591020e3f998145959d08",
        //   "0xb8f699d69df2e33083829d668c2b6786e8ace1933039a31f88223f40f7b16724",
        //   "0xe6d6df4e284e15001e268f1af32139d46bc2691ef6af17dcf09acc7f47048cfa",
        // ],
        merkleProof,
        mintAmount
      )
      .send({
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        console.log(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit tofunft.com to view it.`
        );
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit tofunft.com to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const freeMint = () => {
    console.log("Free Mint");
    blockchain.smartContract.methods
      .freeMint(1)
      .send({ from: blockchain.account })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        console.log(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit tofunft.com to view it.`
        );
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit tofunft.com to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const checkBalance = (account) => {
    blockchain.smartContract.methods
      ?.totalPublicMint(account)
      .call(function (err, res) {
        if (err) {
          console.log(err);
          return;
        }
        console.log("totalPublicMint", res ? res : "no res");
        setPublicMint(res);
      });
  };
  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 50) {
      newMintAmount = 50;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  useEffect(() => {
    console.log(blockchain.account);
    console.log("");
    //  const mp=  await merkleRoot(blockchain.account)
    const error = "You are not in whiteList";
    // console.log(address);
    const addresses = [
      "0xd95aa96c0e04f1a37f41f3f9ce7c00038dce7fef", //rinkeby
      "0xc8af10715e333fbb133dd2094bcfa3f324c59c85", //mytest
      "0x19314f5bf6aed26586334feba57e659b6487671d",
      "0xc8af10715e333fbb133dd2094bcfa3f324c59c85",
      "0x790e672915c31f0e089802a96a8ff789f55af899",
      "0xbaeae29e7457f1e69698449a3ff983cad28a3a75",
      "0x47ee7910969b31bf02d8217b042233b8f1b5423d",
      "0x2d3b5984c56f2dd328f9e4d467289000a4d163de",
      "0xe98cc4afc81350280f1fcb4edb6dfa6888d8fcc9",
      "0xf093210da74a3fcc6aa5cf611c43429fc812bbba",
      "0x91891ee9770e3b798dbca6bb69530bc53d7784d5",
      "0x7a47590a36aebc6dc654dada4afaa3407f7fc008",
      "0xb91309f20d2b839b659d5f24b6ee232edf985a60",
      "0xd80ca1a22e07663af0660ccde9db7c319e02a229",
      "0xbdbeb9c4b3ec97c30de834578ef50f5bc1533e12",
      "0xf3f7c090757e0c01da19e3c5395a169cadf68484",
      "0x3cbdb4b6ada7966923d44b7b4507adf52c9dd3fd",
      "0xe1a188be9a44be95ae5e85bfdd9625760fc79dae",
      "0xf635f3d810c81e19513a6cc4a6a39d54644647c6",
      "0xc441fcd2e080a01f451b63e9b6ba4b524c5e1d58",
      "0x1d415d60dddd135e563a204fdac3b59d4ef0f077",
      "0xd600b4a5595fc4cfc54335cac6c088bfc5ce2804",
      "0xfee68c13acdbba6ebd69942f20550d12050ddfa6",
      "0xf5f3d4b046efba5b8506595db2b40361671c1a7d",
      "0x5a5672df3659206aa8361ae6172651b9ab766849",
      "0x62b14e5d4bd99147d501c8a48badc4a0f938b2a7",
      "0x5f94f42d15e293b8a6e9cb340da4f0ceaaa23840",
      "0x425df35a635ea3ac80b4afa6389cd44d9cc22fa3",
      "0xd4834a961bc10727ca50e8820ba7d3a35d2a6763",
      "0x7ad138c68eb4959e6054130d2290aed6d939666b",
      "0x751db520696bb0f19e0a5b23e28d4864b9491080",
      "0xfe93b7819d4dc124a05ac777f14045b1b278dfd4",
      "0x9b84ac21d7a33affd657ea6562572b8749312aeb",
      "0xf12fb3f8c8f8ff5d5a438f86c2b57f3134150e9f",
      "0xc12f88f1ffd3656c8e62861fb1ec72c34bdbca01",
      "0x85661254b75fc99a549b4cf4b2e03b5069743772",
      "0x3d3e05c726d797dc5683a72b7cedd8f3292a12d3",
      "0x7ca393a7602f33c7be1f2c7dc225dd6aba5c5b30",
      "0x00c36c35259c10b2714473ffb1da813935917821",
      "0x1aad78cbcb86954daf4191989278a6222e06f04f",
      "0x23e0d141f33025a5ea40b3a162d65ead36f4cf17",
      "0x063a3e7c2123a5928a96de786eb3928f1bc43ab6",
      "0xc735a81201408c211c0ceaf2c321a49f3a89bd46",
      "0x94ffc2b6ad43f8afcb6d66184a81be954b483d57",
      "0x905c5978afd4a09619d0006259e6fc68a8cb4d51",
      "0x28424f12ca412ca548c3ed4abc4fce1d50979594",
      "0xcb983df3fc231db1e97d13bd0cb08d3516e1d5a9",
      "0x37f92f5301645e4e5cd415148e9ea34069f587c3",
      "0xabe302690fff19aa5104cb4d6098f77e0846dee5",
      "0xaf88929d5153518c46cdf8bf3d4b8be30f0db223",
      "0x4f1962f27131977851893590d33f262b78e41a18",
      "0x5ead68eb70dabe476623ad0169c201347cefbb12",
      "0xeee0ed9871c6ee1e25c980981b782ca3ac52ad43",
      "0x9bab6f79f9e083e03f6d7af002bd54ab1399a9c2",
      "0x3c7eea9c8ca6686fd6b55a314d1477af05f00b85",
      "0x46866b7d26340021bff7fee1837e733a3c48d9c4",
      "0xdf25f3c1762bedb7a9282ff26a395f7c7fd70ffd",
      "0x4b00b65ce1bf6b2a3d6f88bf22e3ce984fcb6dee",
      "0x04bfec08d20dcf4a0774869a9bd14933a995ea6b",
      "0x51276e843a69790b0578fd216f0485845725a420",
      "0x6a400d4e687510c98cde63fb83d130c4844c8f40",
      "0x06a2c8c2cb83f28206b569858d60adcddb1b07a8",
      "0x11aa281b21a35fe93ef1062e48c66b7108ffbf56",
      "0xa73f5d09e0c5a2966d2b86362ebcb7e8052a2c61",
      "0xe5b0de8f18364beecb2b5861c96652582fc4a9b5",
      "0xdec69ff16ee735714e30c5f2b99a87f196914b6e",
      "0x288c4ec00338cf7dda5a30afe365294e00418b62",
      "0xeabaef7fa5258257905175cb2fee7fa9b4cc4a4a",
      "0xee5e4a7370bcc98d0c92fec32bf16cc08817b0dc",
      "0xa62ee61e6452d9661c2ad0c637a1567352a6bd18",
      "0xba737a2989106d60746180aa36fac2de12b88888",
      "0x21480c9177f83b33584a85b71e2b2bebe1f82c24",
      "0xc12f88f1ffd3656c8e62861fb1ec72c34bdbca01",
      "0x44a7c79d84ff0802c7eda2bca8ca6dd6981cc34f",
      "0x5086420ba10bf0225f7498d68822c42c11421a52",
      "0x85ed7396ba4f02f31463df95c5ea2e426dd84fba",
      "0xeabaef7fa5258257905175cb2fee7fa9b4cc4a4a",
      "0xda6322fdfbf33537b14c6c823ce482c653bb2beb",
      "0x3a847f45957c359c87a8b2a60782f1c18a1b9bf2",
      "0x78b7717c4513b0f9746bbb36fc05967238282534",
      "0xe717023498fc66a8f23d17eed88033e907b34f15",
      "0xb16d3d358cb6359c817fd40764612cf378aba661",
      "0xe1a188be9a44be95ae5e85bfdd9625760fc79dae",
      "0xfc4d9ef6d7c7526a34fe969bf444e2c4fa7bcebb",
      "0x5ae80479dd94422e51f443be13f3df32537baae2",
      "0xb1deaaf2914e522edfb981733d60f66c6177ee62",
      "0x7b61ec8bb6bdff8569a2f0a476d544ab5a48b02e",
      "0xb40ce22e6ce933da9eaa5ee63ecb5fb2dcfdf985",
      "0x5677483093b9e07bbe9164f5e85a5d46e425b203",
      "0x83b359acab40885b8b1d4a2c8d447233d8e003d7",
      "0xb40ce22e6ce933da9eaa5ee63ecb5fb2dcfdf985",
      "0xb16d3d358cb6359c817fd40764612cf378aba661",
      "0xe1a188be9a44be95ae5e85bfdd9625760fc79dae",
      "0xfc4d9ef6d7c7526a34fe969bf444e2c4fa7bcebb",
      "0x5ae80479dd94422e51f443be13f3df32537baae2",
      "0xb1deaaf2914e522edfb981733d60f66c6177ee62",
      "0x7b61ec8bb6bdff8569a2f0a476d544ab5a48b02e",
      "0xb40ce22e6ce933da9eaa5ee63ecb5fb2dcfdf985",
      "0x5677483093b9e07bbe9164f5e85a5d46e425b203",
      "0x83b359acab40885b8b1d4a2c8d447233d8e003d7",
    ];
    const leaves = addresses.map((x) => keccak256(x));
    const l = addresses.map(
      (x) => (keccak256(x), console.log(x.toLowerCase()))
    );
    console.log("leaves=>", leaves);
    const tree = new MerkleTree(leaves, keccak256, { sortPairs: true });
    const buf2hex = (x) => "0x" + x.toString("hex");
    console.log("Root===>", buf2hex(tree.getRoot()));
    console.log(blockchain.account);
    const account = addresses.includes(blockchain.account);
    console.log(account);
    if (account) {
      const leaf = keccak256(blockchain.account); // address from wallet using walletconnect/metamask
      const proof = tree.getProof(leaf).map((x) => buf2hex(x.data));
      const proofArray = proof.map((el) => el);
      setMerkleProof(proofArray);
      console.log(typeof proofArray, proofArray);
      setIsError(false);
      return console.log("proof===>", proof);
    } else {
      setMerkleProof([]);
      return setIsError(true);
    }
  }, [blockchain.account]);
  useEffect(() => {
    if (blockchain.account) checkBalance(blockchain?.account);
  }, [blockchain.account]);

  return (
    <BrowserRouter>
      <div className="app">
        <Header />
        <Routes>
          <Route
            path="/"
            element={
              <React.Fragment>
                <Hero
                  mint={claimNFTs}
                  decrementMintAmount={decrementMintAmount}
                  incrementMintAmount={incrementMintAmount}
                  getData={getData}
                  config={CONFIG}
                  mintAmount={mintAmount}
                  dispatch={dispatch}
                  connect={connect}
                  data={data}
                  blockchain={blockchain}
                  whitelistMint={whiteListMint}
                  error={isError}
                  publicMint={publicMint}
                  freeMint={freeMint}
                />
                {/* <About /> */}
                {/* <Features /> */}
                <Utility />
                {/* <Enter/> */}
                <Roadmap />
                {/* <Prizes/> */}
                <Team />
                {/* <Whitepaper/>         */}
                {/* <Faq /> */}
                {/* <Disclaimer/> */}
              </React.Fragment>
            }
          />
          {/* <Route path="/freebies" element={<Page2/>}/> */}
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
